// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_6SI","cls2":"RelatedWorksCard-cls2_ikl RelatedWorksCard-cls1_6SI"};